import AbstractRepository from "@/repositories/AbstractRepository";

export default class CatalogCompensationRepository extends AbstractRepository {
    protected static resource: string = "ptf-zerowaste-catalogcompensation";

    protected static defaultFields: string[] = [
        "uuid",
        "catalogCode",
        "catalogName",
        "catalogBudget",
        "catalogStrategy",
        "owner.uuid",
        "owner.fullName",
        "hierarchyOwner.uuid",
        "hierarchyOwner.fullName",
        "hierarchyOwner.clientCode4",
        "hierarchyOwner.compensationProgramStartDate",
        "startDate",
        "endDate",
        "isValidated",
        "formattedWeek",
        "validationDeadline",
        "armisBudget",
        "armisBudgetRecommended",
        "factorElevenBudget",
        "factorElevenBudgetRecommended",
        "pressAudience",
        "pressBudget",
        "pressBudgetRecommended",
        "updatedBy.displayName",
        "updatedAt",
        "affichageAudience",
        "affichageBudget",
        "affichageBudgetRecommended",
        "emailAcquisitionAudience",
        "emailAcquisitionBudget",
        "emailAcquisitionBudgetRecommended",
        "catalog.uuid",
        "catalog.name",
        "catalog.document.uuid",
        "catalog.document.link"
    ];
}
